// extracted by mini-css-extract-plugin
module.exports = {"menu":"SettingsDropdown-SettingsDropdown-menu-7945af56"};